import React from "react";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
import { SyncOutlined } from "@ant-design/icons";
import { howItWorksSteps } from "../../../../Utils/staticData";
import "./index.scss";

const JourneyColumn = ({ modifier, heading, steps }) => (
  <div className={`journey-column journey-column--${modifier}`}>
    <div className={`journey-header journey-header--${modifier}`}>{heading}</div>
    <div className="journey-steps">
      {steps.map((step, index) => (
        <div className="journey-step" key={step.title}>
          <div className={`journey-step-icon journey-step-icon--${modifier}`}>
            {step.icon}
          </div>
          <div className="journey-step-body">
            <span className="journey-step-index">Step {index + 1}</span>
            <h4>{step.title}</h4>
            <p>{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const HowItWorks = () => {
  return (
    <div className="how-it-works-wrapper" id="how-it-works">
      <div className="how-it-works-container">
        <div className="section-header">
          <Title level={2} className="section-heading">
            How Stealth Jobs Works
          </Title>
          <Paragraph className="section-subtext">
            Two journeys, one confidential matching engine
          </Paragraph>
        </div>

        <div className="journeys-grid">
          <span className="journeys-connector" aria-hidden="true">
            <SyncOutlined />
          </span>
          <JourneyColumn
            modifier="leaders"
            heading="For Talent"
            steps={howItWorksSteps.leaders}
          />
          <JourneyColumn
            modifier="recruiters"
            heading="For Recruiters"
            steps={howItWorksSteps.recruiters}
          />
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
